import { MailCheck } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";
import {
  CardListActions,
  DefaultBulkActionButtons,
  EditorToolbar,
  MorePagination,
  validation,
} from "../../components";
import { authClient } from "../../server";

const validate = {
  required: [validation.required()],
};
function CreateView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Create
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Dose Email Subscribers created successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect("list", "dose-email-subscribers");
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
      title="Dose Email Subscriber"
    >
      <SimpleForm toolbar={<EditorToolbar />}>
        <TextInput
          fullWidth
          source="email"
          label="Email"
          validate={validate.required}
        />
        <TextInput fullWidth source="first_name" label="First Name" />
        <TextInput fullWidth source="last_name" label="Last Name" />
        <BooleanInput fullWidth source="subscribed" label="Subscribed" />
      </SimpleForm>
    </Create>
  );
}

function EditView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Dose Email Subscribers updated successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect(false);
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      <SimpleForm toolbar={<EditorToolbar showDelete />}>
        <TextInput
          fullWidth
          source="email"
          label="Email"
          validate={validate.required}
        />
        <TextInput fullWidth source="first_name" label="First Name" />
        <TextInput fullWidth source="last_name" label="Last Name" />
        <BooleanInput fullWidth source="subscribed" label="Subscribed" />
      </SimpleForm>
    </Edit>
  );
}

const filters = [
  <TextInput label="Email" source="email" alwaysOn />,
  <TextInput label="First Name" source="first_name" alwaysOn />,
  <TextInput label="Last Name" source="last_name" alwaysOn />,
];

function RenderList(props) {
  const [subscribedCount, setSubscribedCount] = useState();
  const [unsubscribedCount, setUnsubscribedCount] = useState();
  useEffect(() => {
    authClient.get("/admin/dose-email-subscribers/count").then((res) => {
      const json = res.json;
      setSubscribedCount(json.subscribed);
      setUnsubscribedCount(json.unsubscribed);
    });
  }, []);
  return (
    <Fragment>
      {subscribedCount !== undefined && (
        <div
          style={{
            padding: 13,
            fontWeight: "bold",
            fontSize: 18,
            fontFamily: "Roboto",
          }}
        >
          <span style={{ marginRight: 25 }}>
            Total Subscribed: {subscribedCount}
          </span>
          <span>Total Unsubscribed: {unsubscribedCount}</span>
        </div>
      )}
      <Datagrid rowClick="edit" {...props}>
        <TextField source="id" />
        <TextField source="email" label="Email" />
        <TextField source="first_name" label="First Name" />
        <TextField source="last_name" label="Last Name" />
        <BooleanField source="subscribed" label="Subscribed" />
        {/* TODO: add subscribed by */}
      </Datagrid>
    </Fragment>
  );
}

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={filters}
      perPage={50}
      pagination={<MorePagination />}
      title="Dose Email Subscribers"
    >
      <RenderList bulkActionButtons={<DefaultBulkActionButtons />} />
    </List>
  );
}

export const DoseEmailSubscribers = {
  category: "dose",
  name: "dose-email-subscribers",
  list: ListView,
  create: CreateView,
  icon: MailCheck,
  options: { label: "Dose Subscribers" },
  edit: EditView,
};
